import { render, staticRenderFns } from "./InlineNoteEditor.vue?vue&type=template&id=f55be9d0&scoped=true&"
import script from "./InlineNoteEditor.vue?vue&type=script&lang=ts&"
export * from "./InlineNoteEditor.vue?vue&type=script&lang=ts&"
import style0 from "./InlineNoteEditor.vue?vue&type=style&index=0&id=f55be9d0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f55be9d0",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VForm } from 'vuetify/lib/components/VForm';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VMenu } from 'vuetify/lib/components/VMenu';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VForm,VIcon,VMenu,VTextField})
